// extracted by mini-css-extract-plugin
export default {"cartcontainer":"cart_cartcontainer__+k3fW","cartbox":"cart_cartbox__7sdiA","removebtn":"cart_removebtn__qQRs+","price":"cart_price__PxVdE","addbtn":"cart_addbtn__jPNne"};